import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

interface ParallaxElementProps {
    children: React.ReactNode;
    className?: string;
    speed?: number;
    direction?: 'up' | 'down' | 'left' | 'right';
    offset?: string[];
}

const ParallaxElement: React.FC<ParallaxElementProps> = ({
    children,
    className = '',
    speed = 0.5,
    direction = 'up',
    offset = ["start end", "end start"]
}) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: offset as any
    });

    const getTransform = () => {
        const distance = speed * 100;
        switch (direction) {
            case 'up':
                return useTransform(scrollYProgress, [0, 1], [0, -distance]);
            case 'down':
                return useTransform(scrollYProgress, [0, 1], [0, distance]);
            case 'left':
                return useTransform(scrollYProgress, [0, 1], [0, -distance]);
            case 'right':
                return useTransform(scrollYProgress, [0, 1], [0, distance]);
            default:
                return useTransform(scrollYProgress, [0, 1], [0, -distance]);
        }
    };

    const transform = getTransform();

    const getStyle = () => {
        if (direction === 'left' || direction === 'right') {
            return { x: transform };
        }
        return { y: transform };
    };

    return (
        <motion.div
            ref={ref}
            style={getStyle()}
            className={className}
        >
            {children}
        </motion.div>
    );
};

export default ParallaxElement; 
